var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:[_vm.directionClass, _vm.activeClass, _vm.disableClass],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.selectTab.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }